import React, { useCallback, useRef, useState } from 'react';

interface VideoPreviewProps {
    src: string;
    suspended: boolean;
}

// 弹层期间释放原生播放器，防止手机浏览器的视频层覆盖页面弹层。
export default function VideoPreview({ src, suspended }: VideoPreviewProps) {
    const player = useRef<HTMLVideoElement | null>(null);
    const position = useRef(0);
    const [height, setHeight] = useState(146);
    const attachPlayer = useCallback((node: HTMLVideoElement | null) => {
        const previous = player.current;
        if (previous && previous !== node) {
            position.current = previous.currentTime;
            previous.pause();
            previous.removeAttribute('src');
            previous.load();
        }
        player.current = node;
    }, []);

    if (suspended) {
        return <div aria-hidden="true" style={{ width: 260, height }} />;
    }

    return (
        <video
            ref={attachPlayer}
            src={src}
            controls
            playsInline
            webkit-playsinline="true"
            disablePictureInPicture
            preload="metadata"
            style={{ width: 260, height: 'auto' }}
            onLoadedMetadata={(event) => {
                const video = event.currentTarget;
                if (video.videoWidth && video.videoHeight) {
                    setHeight(260 * video.videoHeight / video.videoWidth);
                }
                if (position.current > 0 && Number.isFinite(video.duration)) {
                    video.currentTime = Math.min(position.current, video.duration);
                }
            }}
        />
    );
}
